var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAttach(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.46617 8.27965L13.553 17.0903C14.0161 17.8924 15.0419 18.1673 15.8441 17.7042C16.6463 17.241 16.9211 16.2153 16.458 15.4131L10.2599 4.67775C9.33363 3.07337 7.28212 2.52368 5.67775 3.44996C4.07337 4.37625 3.52368 6.42775 4.44996 8.03213L10.94 19.2732C12.2806 21.5952 15.2498 22.3908 17.5718 21.0502C19.8938 19.7096 20.6894 16.7404 19.3488 14.4184L14.6284 6.24255",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttach);
export default __webpack_public_path__ + "static/media/attach.dfe61d03c1da67e1c3e32c31b0568ea1.svg";
export { ForwardRef as ReactComponent };